import { Fragment, useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Step, StepLabel, Stepper, Typography } from "@mui/material";
import ComponentFormEtapas from "../../components/Form/Etapas/ComponentFormEtapas";
import ChatGPT from "../../components/ChatGPT/ChatGPT";
import { useRespuesta } from "../../data/RespuestaContext";
import { useJobContext } from "../../hooks/Jobs";
import FormProyect from "../../components/Form/FormProyect";
import Propuestas from "../../components/Propuestas/Propuestas";
import { useProyecto } from "../../data/ProyectoContext";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";

const steps = [
  "¿Qué necesitas planificar?",
  "¡Recibe grandes ideas!",
  "Explora en detalle",
  "Recibe planificación",
];

const ABPPage = () => {
  const { etapa, isCompleted, resetState, handleSetTipoEstructuraProyecto } =
    useJobContext();
  const { respuesta } = useRespuesta();
  const [activeStep, setActiveStep] = useState(0);
  const { proyecto, setProyecto } = useProyecto();
  const {
    handleNivelChange,
    handleAsignaturaChangeLocal,
    setPromptData,
    setObjetivosSeleccionados,
  } = useActividadesContext();

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const stepContentMap = [
    <FormProyect onNextStep={handleNext} key="abp_0" />,
    <ComponentFormEtapas
      color="#90AFC5"
      PropuestasComponent={Propuestas}
      key="abp_1"
    />,
    <ComponentFormEtapas
      color="#90AFC5"
      PropuestasComponent={Propuestas}
      key="abp_2"
    />,
    <ChatGPT key="abp_3" respuestaData={respuesta?.propuestas} />,
  ];

  const startABP = async () => {
    resetState();
    setProyecto({
      ...proyecto,
      tipo_estructura: "Aprendizaje basado en proyectos",
      materias: [],
      objetivos_aprendizaje: [],
    });
    setPromptData({});
    await handleNivelChange("", null);
    handleAsignaturaChangeLocal({ id: "", nombre: "" });
    setObjetivosSeleccionados({});
    handleSetTipoEstructuraProyecto("aprendizaje_basado_en_proyectos");
  };
  
  useEffect(() => {
    console.log("cambio en etapa detectado", etapa);
    if (etapa == 0 && !isCompleted) {
      console.log("activando etapa 0");
      setActiveStep(0);
      startABP();
    } else {
      setActiveStep(etapa + 1);
    }
  }, [etapa]);

  return (
    <Fragment>
      <CssBaseline />
      {activeStep > 0 && (
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          sx={{
            "& .MuiStepConnector-line": {
              border: "2px solid #90AFC5",
            },
            m: "auto",
            pt: 5,
            pb: 3,
            width: "80%", // Cambia el color y el grosor de la línea separadora del stepper
            "& .MuiStepIcon-root": {
              color: "#90AFC5", // Color de los pasos no activos
              "&.Mui-completed": {
                color: "#209099", // Color de los pasos completados
              },
              "&.Mui-active": {
                color: "#336B87", // Color del paso activo
              },
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>
                <Typography fontFamily="Montserrat" fontSize="0.8rem">
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      )}
      {activeStep === steps.length ? (
        <Typography variant="subtitle1">En construcción...</Typography>
      ) : (
        stepContentMap[activeStep]
      )}
    </Fragment>
  );
};

export default ABPPage;
